export const privateRoutes = {
    events: '/events',
    teamMembers: '/team',
    subscriptionPlan: '/subscription',
    createOrganisation: '/create-organisation',
    resources: '/resources',
};

export const publicRoutes = {
    login: '/login',
    signup: '/signup',
    bookDemo: '/book-demo',
    stravaLogin: '/strava-login',
    facebookLogin: '/facebook-login',
    googleLogin: '/google-login',
    acceptTeamInvitation: '/accept_team_invitation',
    resetPassword: '/reset-password',
    landing: '/',
};

export const isPrivatePage = pathname => Object.values(privateRoutes).includes(pathname);
export const isPublicPage = pathname => Object.values(publicRoutes).includes(pathname);